module.exports = __webpack_public_path__ + "static/media/marker_restaurant.90e203be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_restaurant.svg
// module id = 241
// module chunks = 0